/* eslint-disable import/prefer-default-export */
import { isLocalDomain } from './domainHelper'

const scriptLoadPromises = {}

export const importWebComponent = ({ server, component, sdkVersion, baseURL }) => {
  let webComponentsURL = baseURL
  if (!webComponentsURL) {
    webComponentsURL = server.getSdkUrl(`v${sdkVersion}`)
    if (isLocalDomain()) webComponentsURL = window.location.origin
  }
  const src = `${webComponentsURL}/web-components/${component}.js`

  if (scriptLoadPromises[src] !== undefined) return scriptLoadPromises[src]

  scriptLoadPromises[src] = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.type = 'module'
    script.crossOrigin = 'anonymous'
    script.async = true
    script.onload = () => {
      resolve()
    }
    script.onerror = () => {
      reject(new Error(`Failed to load script: ${src}`))
    }

    document.head.appendChild(script)
  })

  return scriptLoadPromises[src]
}
